import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const fanton: ProjectContentData = {
  id: 'fanton',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'ton',
          value: 'TON',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '500,000,000.00',
          name: 'Total Supply',
          description: <span>Displays the total token supply.</span>,
        },
        {
          id: 'initial-circulation-supply',
          value: '47,125,000',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              Shows the circulating supply at the
              <br />
              Token Generation Event (TGE).
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '$1,131,000',
          name: 'Initial Market Cap',
          description: (
            <span>
              Reflects the initial
              <br />
              market cap at the TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$150,000',
          description: (
            <span>
              Total funds targeted to be
              <br />
              raised across all pools in this Token Sale.
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'EAT Price',
          value: '$0.023',
          description: (
            <span>
              Price per token
              <br />
              during the Token Sale.
            </span>
          ),
        },
        {
          id: 'up-to-25k',
          name: 'Deposit Range',
          value: 'Up to $25,000',
          description: (
            <span>
              Range of allocation sizes for
              <br />
              participation in the FCFS Pools.
              <br />
              The allocation sizes in the Pro-
              <br />
              Rata Pools will be determined
              <br />
              based on the relative buying
              <br />
              power of the entire pool.
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for Token Sale participation.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'tge',
          value: '20 %',
          name: 'At TGE',
          description: (
            <span>
              Percentage of tokens
              <br />
              claimable/distributed at the TGE.
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '0 months',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '8 months',
          name: 'Linear Vesting',
          description: (
            <span>
              Token distribution
              <br />
              schedule post-cliff period.
            </span>
          ),
        },
      ],
    },
    {
      id: 'eat',
      label: 'EAT Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'sale-start',
          value: '07.08.2024',
          name: 'Sale Start',
          description: <span>Start date of the Token Sale.</span>,
        },
        {
          id: 'sale-end',
          value: '10.08.2024',
          name: 'Sale End',
          description: <span>End date of the Token Sale.</span>,
        },
        {
          id: 'pre-market-date',
          name: 'Pre-Market Date',
          value: '12.08.2024',
          description: (
            <span>
              Starting date of the Pre-Market
              <br />
              OTC Trading
            </span>
          ),
        },
      ],
    },
  ],
};
